/** --------------------------------------------------------------------------------------------------------------------
 * @fileOverview companent for handling the "FinancialReportCompany"
 * use <CustomModal/> component for show driver report and send current date wiht selected company from
 * React.Context<ComapnyScreenContext> and send to API.get.administrator.getCompanyDeposite()
 * and save to queryKey<values.useQueryKeys.getDepositPrice4Company>
 *
 *   - have local variable
 *   - call API's
 *   - have local function :: for caling API and update data ( FinancialReportComapny )
 *   - retrun JSX view
 */

import api                  from '../../../../api';
import React                from 'react';
import utils                from '../../../../utils';
import values               from '../../../../values';
import Context              from '../../../../context';
import Cookies              from 'js-cookie';
import constants            from '../../../../values/constants';
import Components           from './components';
import convertNumberToPrice from '../../../../utils/convertNumberToPrice';

import {
  CustomView     ,
  CustomModal    ,
  TableHeader    ,
  CustomInput    ,
  TableLoading   ,
  TableNullData  ,
  CustomButton2  ,
  UserInformation,
  CustomTimePiker,
} from '../../../../components';

import { useTranslation           } from 'react-i18next';
import { useQuery, UseQueryResult } from 'react-query';

import './index.scss';

const PayAllServices: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const today: Date = new Date();

  const year : number = today.getFullYear();
  const month: string = String(today.getMonth() + 1).padStart(2, '0');
  const day  : string = String(today.getDate ()    ).padStart(2, '0');

  const formattedDate: string = `${year}-${month}-${day}`;

  const { showModal, setShowModal, selectedCompany, payCompanyDeposit } =
    React.useContext(Context.CompanyScreen);

  const [isLoading , setIsLoading ] = React.useState<boolean>(false);
  const [expireDate, setExpireDate] = React.useState<string | undefined>(new Date().toISOString());

  const userType = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));

  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const companyFinancialReports:  UseQueryResult<any, unknown> = useQuery(
    [values.useQueryKeys.getDepositPrice4Company, selectedCompany?._id, expireDate],
    () => api.get.administrator.getCompanyDeposite( selectedCompany?._id as string, expireDate),
    {enabled: showModal === "PAY_COMPANY_DEPOSITE", cacheTime: 1000}
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function onSubmitPay (): Promise<void> {
    setIsLoading(true);
    await payCompanyDeposit!(selectedCompany?._id as string, expireDate as string);
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="show-company-deposit-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "PAY_COMPANY_DEPOSITE"}
        minWidth={"60vw"}
        maxWidth={"90vw"}
        height={"75vh"}
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedCompany?.firstName}
                avatar={selectedCompany?.avatar}
                isBlock={!selectedCompany?.driverInformation?.approved?.isApproved}
                lastName={selectedCompany?.lastName}
                phoneNumber={selectedCompany?.phoneNumber}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="user-information-container">
            <CustomView.Column className='callendar-wrapper'>
              <p className='callendar-text'>تاریخ پایان :</p>
              <CustomTimePiker
                isIsoDate
                isRemoveable
                defaultValue={expireDate}
                onChange={(event: string): void => {setExpireDate(event);}}
                maxDate={new Date()}
                format='YYYY-MM-DD'
              />
            </CustomView.Column>
          </CustomView.Row>
          <div className="table-content-wrapper">
            <table className="table-tag-class-name">
              <TableHeader headers={values.tableHeaders.COMPANY_DIPOSIT_DRIVER_LIST}/>
              {companyFinancialReports.status === "loading" ? (<TableLoading />) : (
                companyFinancialReports?.data?.result?.driversList?.length <= 0 ||
                  !companyFinancialReports?.data?.result?.driversList) ? (
                  <TableNullData text={t("driver_has_not_active_service")} />
                ): (<Components.PayDepositTable driversList={companyFinancialReports?.data?.result?.driversList} />)
              }
            </table>
          </div>
            <CustomView.Container className="approve-form-content">
              <>
                <CustomView.Row className="content-center">
                  <CustomView.Column medium={12}>
                    <CustomView.Row className="radio-button-group">
                      <CustomView.Column medium={6} className="form-colum dropdown">
                        <CustomInput
                          id="fishNumber"
                          name="fishNumber"
                          label={'مجموع کل قیمت'}
                          value={String(
                            convertNumberToPrice(
                              companyFinancialReports?.data?.result?.totalAmount)
                          ) + ' ' + t("toman")}
                          isDisable
                        />
                      </CustomView.Column>
                      <CustomView.Column medium={6} className="form-colum">
                        <CustomInput
                          name="totalPriceDriverToPay"
                          id="totalPriceDriverToPay"
                          label={'مجموع سهم شرکت'}
                          value={String(
                              convertNumberToPrice(
                                companyFinancialReports?.data?.result?.totalShareCompany)
                          ) + ' ' + t("toman")}
                          isDisable
                        />
                      </CustomView.Column>
                    </CustomView.Row>
                  </CustomView.Column>
                </CustomView.Row>
                <br />
              </>
            </CustomView.Container>
            <div className="pay-button">
              {(userType === "ADMIN" || userType === "COMPANY") && (
                <CustomButton2 title={'تسویه با شرکت'} onClick={onSubmitPay} isLoading={isLoading}/>
              )}
            </div>
        </CustomView.Container>
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default PayAllServices;
